(() => {
  if (window.RoomieLuxuryCart) return;
  window.RoomieLuxuryCart = true;


  const placeCartCashback = () => {
    const form = document.getElementById('CartPageForm');
    const widget = document.querySelector('main .shopify-app-block[id*="koin_cart_widget"]');
    const checkout = form?.querySelector('.cart__checkout-wrapper')?.closest('.cart__item-row');
    if (widget && checkout && widget.nextElementSibling !== checkout) checkout.before(widget);
  };
  placeCartCashback();
  const cartMain = document.querySelector('main');
  if (cartMain && document.body.classList.contains('template-cart')) {
    new MutationObserver(placeCartCashback).observe(cartMain, {childList:true,subtree:true});
  }

  const root = () => window.Shopify?.routes?.root || '/';

  const formatMoney = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency',
    currency: currency || 'GBP'
  }).format(cents / 100);

  const renderCartState = (cart) => {
    document.querySelectorAll('[data-subtotal]').forEach((subtotal) => {
      subtotal.textContent = formatMoney(cart.total_price, cart.currency);
    });

    const hasMerchandise = cart.items.some((item) => !['shipping-insurance', 'shipping-protection'].includes(item.handle));
    document.querySelectorAll('[data-cart-shipping-achievement]').forEach((achievement) => {
      achievement.hidden = !hasMerchandise;
    });
  };

  const notifyCart = async (addedProduct, updatedCart) => {
    const cart = updatedCart || await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
    renderCartState(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:build'));
    return cart;
  };

  const setProtectionState = (container, enabled) => {
    const input = container.querySelector('[data-cart-protection-toggle]');
    if (input) input.checked = enabled;
  };

  const changeProtection = async (container, enabled) => {
    const variantId = Number(container.dataset.variantId);
    if (!variantId) return;

    container.classList.add('is-loading');
    const input = container.querySelector('[data-cart-protection-toggle]');
    if (input) input.disabled = true;

    try {
      const cart = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      const existing = cart.items.filter((item) => Number(item.variant_id) === variantId);
      let addedProduct = null;
      let updatedCart = null;

      if (enabled && existing.length === 0) {
        const response = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        addedProduct = await response.json();
        if (!response.ok) throw new Error(addedProduct.description || 'Unable to add shipping protection.');
      } else {
        const updates = {};
        existing.forEach((item, index) => {
          updates[item.key] = enabled && index === 0 ? 1 : 0;
        });

        const response = await fetch(`${root()}cart/update.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        updatedCart = await response.json();
        if (!response.ok) throw new Error(`Unable to ${enabled ? 'add' : 'remove'} shipping protection.`);
      }

      if (!updatedCart) {
        updatedCart = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      }
      setProtectionState(container, enabled);
      await notifyCart(addedProduct, updatedCart);
    } catch (error) {
      setProtectionState(container, !enabled);
      const message = container.querySelector('[data-cart-protection-error]');
      if (message) message.textContent = error.message;
    } finally {
      container.classList.remove('is-loading');
      if (input) input.disabled = false;
    }
  };

  const replaceVariant = async (dialog) => {
    const select = dialog.querySelector('[data-cart-edit-select]');
    const button = dialog.querySelector('[data-cart-edit-confirm]');
    const error = dialog.querySelector('[data-cart-edit-error]');
    const lineKey = dialog.dataset.lineKey;
    const currentVariant = Number(dialog.dataset.currentVariant);
    const newVariant = Number(select?.value);
    const quantity = Number(dialog.dataset.quantity || 1);
    const upgradeCheckbox = dialog.querySelector('[data-cart-deep-upgrade]');
    const upgradeVariantId = Number(upgradeCheckbox?.dataset.upgradeVariantId);
    const wantsDeepUpgrade = Boolean(upgradeCheckbox?.checked && upgradeVariantId);

    if (!newVariant || !lineKey) return;

    button.disabled = true;
    button.textContent = 'Updating…';
    if (error) error.textContent = '';

    try {
      let properties = {};
      try {
        const parsedProperties = JSON.parse(dialog.dataset.properties || '{}');
        if (Array.isArray(parsedProperties)) {
          properties = parsedProperties.reduce((result, property) => {
            if (Array.isArray(property) && property.length >= 2) {
              result[property[0]] = property[1];
            } else if (property && typeof property === 'object') {
              const name = property.name ?? property.key ?? property[0];
              const value = property.value ?? property[1];
              if (name != null && value != null) result[name] = value;
            }
            return result;
          }, {});
        } else if (parsedProperties && typeof parsedProperties === 'object') {
          properties = parsedProperties;
        }
      } catch (parseError) {
        properties = {};
      }

      const cart = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      const originalLine = cart.items.find((item) => item.key === lineKey);
      if (!originalLine) throw new Error('This cart item has changed. Please refresh your cart and try again.');
      const originalProperties = JSON.stringify(originalLine.properties || {});
      const selectedOption = select.options[select.selectedIndex]?.textContent || '';
      const managesUpgrade = selectedOption.toLowerCase().includes('fitted sheet');
      const existingUpgrade = cart.items.find((item) => Number(item.variant_id) === upgradeVariantId);
      const itemsToAdd = [];
      if (newVariant !== currentVariant) itemsToAdd.push({ id: newVariant, quantity, properties });
      if (wantsDeepUpgrade && !existingUpgrade) itemsToAdd.push({ id: upgradeVariantId, quantity: 1 });

      let addedProduct = null;
      if (itemsToAdd.length) {
        const addResponse = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
        addedProduct = await addResponse.json();
        if (!addResponse.ok) throw new Error(addedProduct.description || 'This option is unavailable.');
      }

      if (managesUpgrade && !wantsDeepUpgrade && existingUpgrade) {
        const upgradeResponse = await fetch(`${root()}cart/change.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: existingUpgrade.key, quantity: 0 })
        });
        if (!upgradeResponse.ok) throw new Error('The deep fitted-sheet upgrade could not be updated.');
      }

      if (newVariant !== currentVariant) {
        const refreshedCart = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
        const originalItem = refreshedCart.items.find((item) => Number(item.variant_id) === currentVariant && JSON.stringify(item.properties || {}) === originalProperties);
        if (!originalItem) throw new Error('The original cart item could not be found.');
        const removeResponse = await fetch(`${root()}cart/change.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: originalItem.key, quantity: 0 })
        });
        if (!removeResponse.ok) throw new Error('The original size could not be removed.');
      }

      dialog.close();
      await notifyCart(addedProduct);
    } catch (requestError) {
      if (error) error.textContent = requestError.message;
    } finally {
      button.disabled = false;
      button.textContent = 'Update size';
    }
  };

  document.addEventListener('change', (event) => {
    const toggle = event.target.closest('[data-cart-protection-toggle]');
    if (toggle) changeProtection(toggle.closest('[data-cart-protection]'), toggle.checked);

    const variantSelect = event.target.closest('[data-cart-edit-select]');
    if (variantSelect) {
      const selectedText = variantSelect.options[variantSelect.selectedIndex]?.textContent || '';
      const upgradeRow = variantSelect.closest('[data-cart-edit-dialog]')?.querySelector('[data-cart-deep-upgrade-row]');
      if (upgradeRow) upgradeRow.hidden = !selectedText.toLowerCase().includes('fitted sheet');
      if (upgradeRow?.hidden) {
        const checkbox = upgradeRow.querySelector('[data-cart-deep-upgrade]');
        if (checkbox) checkbox.checked = false;
      }
    }
  });

  window.addEventListener('click', (event) => {
    const open = event.target.closest?.('[data-cart-edit-open]');
    if (!open) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const dialog = document.querySelector(`[data-cart-edit-dialog="${CSS.escape(open.dataset.dialogId)}"]`);
    if (dialog && !dialog.open) dialog.showModal();
  }, true);

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-edit-open]');
    const close = event.target.closest('[data-cart-edit-close]');
    const confirm = event.target.closest('[data-cart-edit-confirm]');

    if (open) {
      event.preventDefault();
      event.stopPropagation();
      const dialog = document.querySelector(`[data-cart-edit-dialog="${CSS.escape(open.dataset.dialogId)}"]`);
      if (dialog) dialog.showModal();
    }
    if (close) {
      event.preventDefault();
      event.stopPropagation();
      close.closest('dialog')?.close();
    }
    if (confirm) {
      event.preventDefault();
      event.stopPropagation();
      replaceVariant(confirm.closest('dialog'));
    }
  });

  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail?.cart;
    if (!cart?.items) return;
    renderCartState(cart);
    document.querySelectorAll('[data-cart-protection]').forEach((container) => {
      const variantId = Number(container.dataset.variantId);
      setProtectionState(container, cart.items.some((item) => Number(item.variant_id) === variantId));
    });
  });
})();
